import AppError from "@/pages/app-error";
import AppLayout from "@/pages/app-layout";
import AppStandalone from "@/pages/app-standalone";
import LoginPage from "@/pages/login";
import LoginSSOPage from "@/pages/login-sso";
import SSOPage from "@/pages/sso";
import { RouteObject } from "react-router-dom";
import ApprenticeshipRoute from "./apprenticeship";
import BillingRoute from "./billing";
import BookingRoute from "./booking";
import CalendarRoute from "./calendar";
import ContentRoute from "./content";
import DashboardRoute from "./dashboard";
import ListViewRoute from "./list_view";
import MedRepRoute from "./medrep";
import NotificationsRoute from "./notifications";
import RegistrationRoute from "./registration";
import SearchRoute from "./search";
import SettingsRoute from "./settings";
import SFLikeRoute from "./sf_like";
import SFRedirectRoute from "./sf_redirect";
import DialerSimulatorStandaloneRoute from "./standalone/dialer-simulator";
import DialerWorkflowEditorRoute from "./standalone/dialer-workflow-editor";
import StandaloneRoute from "./standalone";
import TargetRoute from "./target";
import TasksRoute from "./tasks";
import ToolsRoute from "./tools";
import UtilsRoute from "./utils";

const AppRoutes: RouteObject[] = [
    {
        path: "/",
        element: <AppLayout />,
        children: [
            {
                errorElement: <AppError />,
                children: [
                    DashboardRoute,
                    CalendarRoute,
                    TasksRoute,
                    SearchRoute,
                    BillingRoute,
                    ToolsRoute,
                    RegistrationRoute,
                    ApprenticeshipRoute,
                    ContentRoute,
                    UtilsRoute,
                    SettingsRoute,
                    TasksRoute,
                    BookingRoute,
                    MedRepRoute,
                    NotificationsRoute,
                    TargetRoute,
                    SFLikeRoute,
                    SFRedirectRoute,
                    ListViewRoute
                ]
            }
        ],
        errorElement: <AppError />
    },
    {
        // Screens that own the whole window: no main menu, no page scroll around them.
        path: "/",
        element: <AppStandalone />,
        children: [
            {
                errorElement: <AppError />,
                children: [StandaloneRoute, DialerWorkflowEditorRoute, DialerSimulatorStandaloneRoute]
            }
        ],
        errorElement: <AppError />
    },
    {
        path: "/connexion",
        element: <LoginPage />
    },
    {
        path: "/connexion/sso",
        element: <LoginSSOPage />
    },
    {
        path: "/sso",
        element: <SSOPage />
    }
];

export default AppRoutes;
